import {
   CForm, CRow, CFormLabel, CFormInput, CButton, CCol, CImage, CInputGroup, CDivider, CBody, CModal,
   CCardBody, CFormTextarea
} from '@coreui/react'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AxiosInstance from 'src/components/Axios';

const tokenStr = localStorage.getItem('user')
const header = { headers: { Authorization: `Bearer ${tokenStr}`, accept: 'application/json' } }
const urlApi = '/subpoena_items'
const urlApi1 = '/subpoenas'


export default function MyDirective({ dataItem, subpoenaId, setDataState, role, dataState }) {



   // стан для модального вікна до виправлення
   const [showPhotoModal, setShowPhotoModal] = useState(false);

   // стан для модального вікна до виправлення
   const [showPhotoModalFixed, setShowPhotoModalFixed] = useState(false);

   // стан для фото
   const [photo, setPhoto] = useState(null)

   // Для видалення старого фото після завантаження нового
   const [deleteOldPhotoId, setdeleteOldPhotoId] = useState(
      // data?.photo?.id != undefined ? data.photo.id : '',
      dataItem?.imageAfter?.id !== undefined ? dataItem.imageAfter.id : ""
   )
   //субпоена айтем
   const [currentItem, setCurrentItem] = useState()
   const [isLoading, setIsLoading] = useState(false)
   //стан для выдстеження стану онлайн офлайн
   const [isOnline, setIsOnline] = useState(navigator.onLine);


   useEffect(() => {
      const goOnline = () => setIsOnline(true);
      const goOffline = () => setIsOnline(false);

      window.addEventListener('online', goOnline);
      window.addEventListener('offline', goOffline);

      return () => {
         window.removeEventListener('online', goOnline);
         window.removeEventListener('offline', goOffline);
      };
   }, []);

   console.log('dateItem', dataItem)
   // console.log('subpoenaId', subpoenaId)
   // console.log('dataState', dataState)

   function getSubpoena(id) {
      AxiosInstance.get(
         `${urlApi1}/${id}`,
         // data_response,
         header,
      ).then(
         (response) => {
            setDataState(response.data)

         }
      )
   }



   //логіка для додавання фото
   const handleAddPhoto = async () => {
      try {
         // Створити URL для відправки файлу з фото
         const url = process.env.REACT_APP_SERVER_URL + '/api/media_objects'

         if (photo) {
            const formData = new FormData()
            formData.append('file', photo)
            formData.append('name', photo.name)

            // Завантажити фото на сервер
            const responsePhoto = await AxiosInstance.post(url, formData, header)

            // Привязування фото до subpoena_items
            if (responsePhoto.status === 201) {
               console.log('responsePhoto', responsePhoto)
               // Іd фото для можливого подільшого видалення після завантаження нового
               setdeleteOldPhotoId(responsePhoto.data.id)

               const utcNow = dayjs().toISOString()

               const data_response = {
                  imageAfter: `/api/media_objects/${responsePhoto.data.id}`,
                  dateAfter: utcNow
               }
               console.log('data_response', data_response)
               const responseAddPhoto = AxiosInstance.patch(
                  // `${urlApi}/${data.id}`,
                  `${urlApi}/${dataItem.id}`,
                  data_response,
                  header,
               )

               // getSubpoena(subpoenaId)


               // видалення старого фото
               // if (data.photo.id) {
               if (deleteOldPhotoId) {
               }
            }
         }

         // Отримати оновлені дані після завантаження файлу
         // const response1 = await AxiosInstance.get(`${urlApi}/${data.id}`, header)
         //  const response1 = await AxiosInstance.get(`${urlApi1}/${subpoenaId}`, header)
         //             console.log('response1.data', response1.data)
         //             setDataState(response1.data)

         setPhoto(null)
         setTimeout(() => {
            getSubpoena(subpoenaId)
            setPhoto(null)
         }, 500)
      } catch (error) {
         console.error('Сталася помилка під час обробки запиту', error)
      }
   }

   // логіка для вибору фото
   const handlePhotoChange = (event) => {
      const selectedPhoto = event.target.files[0];
      console.log('selectedPhoto', selectedPhoto)

      // Перевірка, чи обраний файл є файлом у форматі JPEG або PNG
      if (selectedPhoto && (selectedPhoto.type === 'image/jpeg' || selectedPhoto.type === 'image/png')) {
         // Перевірка, чи розмір файлу не перевищує 10 МБ
         if (selectedPhoto.size <= 1024 * 1024 * 10) { // 9 MB
            setPhoto(selectedPhoto);
            // console.log('Фото успішно вибрано:', selectedPhoto);
            toast.success('Фото успішно вибрано:')
         } else {
            // console.log('Розмір файлу перевищує 10 МБ.');
            toast.warning('Розмір файлу перевищує 10 МБ.')
         }
      } else {
         // console.log('Оберіть файл у форматі JPEG або PNG.');
         toast.warning('Оберіть файл у форматі JPEG або PNG.')
      }
   }




   //Логіка зміни статуса в subpoenaItems

   function changeStatusForSendToVerify() {
      const data_response = { synkStatus: 'send_to_verify', dateAfter: dayjs().toISOString() }
      AxiosInstance.patch(
         `${urlApi}/${dataItem.id}`,
         data_response,
         header,
      ).then(
         (response) => {
            // console.log(response)
            getSubpoena(subpoenaId)
         }
      )
   }
   function changeStatusToVerified() {
      const data_response = { synkStatus: 'verified' }
      AxiosInstance.patch(
         `${urlApi}/${dataItem.id}`,
         data_response,
         header,
      ).then(
         (response) => {
            getSubpoena(subpoenaId)

         }
      )
   }

   //функція з алертом,для умовної перевірки

   async function verified() {
      try {
         await confirmAlert({
            title: 'Увага',
            message: 'Ви впевнені що хочите підтвердити цей пункт ?',
            buttons: [
               {
                  label: 'Так',
                  onClick: async () => changeStatusToVerified()
               },
               {
                  label: 'Ні',
                  onClick: () => {
                     return
                  },
               },
            ],
         })
      } catch (error) {
         console.error('Помилка видалення:', error)
      }
   }

   //зміна статуса на rejected

   function changeStatusToRejected() {
      const data_response = { synkStatus: 'rejected', dateAfter: null }
      AxiosInstance.patch(
         `${urlApi}/${dataItem.id}`,
         data_response,
         header,
      ).then(
         (response) => {
            // console.log(response)
            getSubpoena(subpoenaId)
         }
      )
   }

   //функція з алертом,для умовної перевірки

   async function rejected() {
      try {
         await confirmAlert({
            title: 'Увага',
            message: 'Ви впевнені що хочите підтвердити цей пункт ?',
            buttons: [
               {
                  label: 'Так',
                  onClick: async () => changeStatusToRejected()
               },
               {
                  label: 'Ні',
                  onClick: () => {
                     return
                  },
               },
            ],
         })
      } catch (error) {
         console.error('Помилка видалення:', error)
      }
   }

   //(верх)зміна статуса на rejected


   function changeStatusToNew() {
      setIsLoading(true)
      const data_response = { synkStatus: 'new' }
      AxiosInstance.patch(
         `${urlApi}/${dataItem.id}`,
         data_response,
         header,
      ).then(
         (response) => {
            console.log(response)
            getSubpoena(subpoenaId)

         }
      ).catch(e => console.log(e)).finally(() => setIsLoading(false))
   }

   //функція з алертом,для умовного повернення партнеру

   async function changeToNew() {
      try {
         await confirmAlert({
            title: 'Увага',
            message: 'Ви впевнені що хочите повернути на доопрацювання ?',
            buttons: [
               {
                  label: 'Так',
                  onClick: async () => changeStatusToNew()
               },
               {
                  label: 'Ні',
                  onClick: () => {
                     return
                  },
               },
            ],
         })
      } catch (error) {
         console.error('Помилка видалення:', error)
      }
   }


   if (isLoading) {

      return (
         <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
            <div className="spinner-border" role="status" style={{ width: '3rem', height: '3rem' }}>
               <span className="visually-hidden">Загрузка...</span>
            </div>
         </div>
      );

   }

   // console.log('url',)

   return (
      <>
         {/* Popup про успішні зміни (справа зверху) */}
         <ToastContainer />
         <hr />


         <CCardBody
            // onSubmit={handleSubmit}
            className="mb-3 mt-3">


            {/* Відображати тільки для Адміна -блок підтвердження*/}
            {
               (role === "ROLE_ADMIN") &&
               <div className="d-flex align-items-center">
                  {/* Затвердити файли (status="verified") */}
                  {
                     (dataItem?.synkStatus === "send_to_verify") &&
                     <CButton
                        className="ms-3"
                        onClick={verified}
                        color="success"
                     >
                        Підтвердити
                     </CButton>
                  }

                  {/* Пункт повернуто */}
                  {
                     (dataItem?.synkStatus === "rejected") &&
                     <CButton
                        className="ms-3"
                        // onClick={verified}
                        color="danger"
                     >
                        Повернуто на доопрацювання
                     </CButton>
                  }

                  {/* Повернути файли на доопрацювання змінити(status="rejected") */}
                  {
                     (dataItem?.synkStatus === "send_to_verify") &&
                     <>
                        <CButton
                           className="ms-3"
                           onClick={rejected}
                           color="danger"
                        >
                           Повернути
                        </CButton>
                     </>
                  }
                  {/* Коли перевірено */}
                  {
                     (dataItem?.synkStatus === "verified") &&
                     <>
                        <CButton
                           className="ms-3"
                           color="primary"
                        >
                           Перевірено
                        </CButton>
                     </>
                  }

                  {
                     (dataItem?.synkStatus === "synced") &&
                     <>
                        <CButton
                           className="ms-3"
                           color="btn-warning"
                        >
                           Внесено в 1c
                        </CButton>
                     </>
                  }

               </div>
            }

            {/* Блок який выдображається для партнера зі статусом */}
            {role === 'ROLE_PARTNER' &&
               <div className='d-flex align-items-center mb-3 mt-4'>
                  {dataItem?.synkStatus === 'new' &&
                     <h5 style={{ color: 'green' }}>Будь ласка, завантажте фото виправлення порушення і відправте пункт на перевірку!</h5>
                  }
                  {dataItem?.synkStatus === 'send_to_verify' &&
                     <h5 style={{ color: 'green' }}>Пункт буде перевірено найближчим часом. Очікуйте!</h5>
                  }
                  {dataItem?.synkStatus === 'verified' &&
                     <h5 style={{ color: 'blue' }}>Ваш пункт порушення перевірено</h5>
                  }
                  {dataItem?.synkStatus === 'rejected' &&
                     <h5 style={{ color: 'red' }}>Пункт порушення не виправлено.Завантажте фото і повторно відправте на перевірку.</h5>
                  }
                  {dataItem?.synkStatus === 'synced' &&
                     <h5 style={{ color: 'red' }}>Порушення виправлено.</h5>
                  }

               </div>
            }
            <CRow
            // className="d-flex"
            >

               <CCol className='md-8'>
                  <div style={{ maxWidth: '500px', marginRight: '100px' }}>
                     <CCol className="mb-3">
                        <CFormLabel htmlFor="exampleFormControlInput1">Пункт порушення</CFormLabel>
                        <CFormInput
                           type="text"
                           id="exampleFormControlInput1"
                           value={dataItem.state}
                           disabled={true}
                           autoComplete="off"
                           required
                        />
                     </CCol>

                     <CCol className="mb-3">
                        <CFormLabel htmlFor="exampleFormControlInput1">Дата створення</CFormLabel>
                        <CFormInput
                           type="text"
                           id="exampleFormControlInput1"
                           value={dayjs(dataItem.dateCreate).local().format('DD.MM.YYYY HH:mm')}
                           disabled={true}
                           autoComplete="off"
                           required
                        />
                     </CCol>

                     <CCol className="mb-3">
                        <CFormLabel htmlFor="exampleFormControlInput1">Термін усунення</CFormLabel>
                        <CFormInput
                           type="text"
                           id="yearOfBirthInput"
                           value={dayjs(dataItem.dateEnd).local().
                              format('DD.MM.YYYY')
                           }
                           disabled={true}
                           autoComplete="off"
                           required
                        />

                     </CCol>

                     {/* Текстареа з описом */}
                     <CCol className="mb-3">
                        <CFormLabel htmlFor="terminationTextarea">Опис</CFormLabel>
                        <CFormTextarea
                           id="terminationTextarea"
                           value={dataItem?.description}
                           disabled={true}
                           autoComplete="off"
                           required
                           rows={4}
                        />
                     </CCol>
                     {/* Текстареа з описом */}


                     {/* Блок виправленого зауваження */}
                     <hr />
                     <CCol className="mb-3 mt-3">
                        <CFormLabel htmlFor="exampleFormControlInput1">Дата виправлення</CFormLabel>
                        <CFormInput
                           type="text"
                           id="yearOfBirthInput"
                           value={dataItem?.dateAfter ? dayjs(dataItem?.dateAfter).local().format('DD.MM.YYYY HH:mm') : "Очікує виправлення"}
                           disabled={true}
                           autoComplete="off"
                           required
                        />

                     </CCol>
                     <CCol className='md-4'>

                     </CCol>

                  </div>
               </CCol>
               {/* Блок фото зауваження */}
               <CCol className='md-4'>
                  {(!isLoading && dataItem?.imageBefore?.contentUrl) ? <>
                     {(!isLoading && dataItem?.imageBefore?.contentUrl) ? <h4>Фото зауваження</h4> : ''}
                     {/* Модалка */}
                     {isOnline ? <CModal
                        visible={showPhotoModal}
                        onClose={() => setShowPhotoModal(false)}
                        size="xl"
                        alignment="center"
                     >
                        <img
                           src={process.env.REACT_APP_SERVER_URL + dataItem.imageBefore.contentUrl}
                           alt="фото"
                           style={{
                              // width: '100%',
                              height: '100vh', objectFit: 'cover', borderRadius: '8px'
                           }}
                        />
                     </CModal> : ''}

                     {(!isLoading && dataItem?.imageBefore?.contentUrl) ? <img key={dataItem.imageBefore.contentUrl}
                        onClick={() => {
                           if (!isOnline) return
                           if (dataItem?.imageBefore?.contentUrl) {
                              setShowPhotoModal(true)
                           }
                        }}

                        // {() => setShowPhotoModal(true)}
                        src={process.env.REACT_APP_SERVER_URL + dataItem.imageBefore.contentUrl}
                        alt="фото"
                        style={{
                           width: '100%', height: '300px',
                           //  height: 'auto',
                           objectFit: 'cover', borderRadius: '8px', cursor: 'pointer'
                        }}
                     /> : ''}

                     <h4>Для збільшення зображення натисніть на фото</h4>
                  </> : ''}

                  {(dataItem?.synkStatus === 'new' || dataItem?.synkStatus === 'rejected') && <>
                     <div className="mb-3">
                        <CFormInput
                           type="file"
                           id="exampleFormControlFile1"
                           onChange={handlePhotoChange}
                           multiple
                        />
                     </div>

                     <div>
                        <CButton onClick={handleAddPhoto}
                           color="success"
                           disabled={!photo ? true : false}
                        >
                           Додати фото
                        </CButton>
                     </div>
                  </>
                  }

                  {/* //Блок завантаженого зображення(виправлення пункту припису) */}
                  {(!isLoading && dataItem?.imageAfter?.contentUrl) ? <div className='mb-3 mt-3'>
                     <h4>Виправлення </h4>
                     {/* Модалка */}
                     {isOnline ? <CModal
                        visible={showPhotoModalFixed}
                        onClose={() => setShowPhotoModalFixed(false)}
                        size="xl"
                        alignment="center"
                     >
                        <img
                           src={process.env.REACT_APP_SERVER_URL + dataItem.imageAfter.contentUrl}
                           alt="фото"
                           style={{
                              // width: '100%',
                              height: '100vh', objectFit: 'cover', borderRadius: '8px'
                           }}
                        />
                     </CModal> : ''}

                     {(!isLoading && dataItem?.imageAfter?.contentUrl) ? <img
                        onClick={() => {
                           if (!isOnline) return
                           if (dataItem?.imageAfter?.contentUrl) {
                              setShowPhotoModalFixed(true)
                           }
                        }}
                        // {() => setShowPhotoModalFixed(true)}
                        src={process.env.REACT_APP_SERVER_URL + dataItem.imageAfter.contentUrl}
                        alt="фото"
                        style={{
                           cursor: 'pointer',
                           width: '100%', height: '300px',
                           //  height: 'auto',
                           objectFit: 'cover', borderRadius: '8px'
                        }}
                     /> : ''}


                     <h4>Для збільшення зображення натисніть на фото</h4>


                  </div> : ''}
               </CCol>
            </CRow>

            {(role === 'ROLE_PARTNER'

            ) &&
               <>
                  {(
                     dataItem.synkStatus === 'verified' ||
                     dataItem.synkStatus === 'synced') ? '' : <>
                     {

                        <div>
                           <CButton
                              onClick={changeStatusForSendToVerify}
                              color="success"
                              disabled={dataItem?.synkStatus !== "new" && dataItem?.synkStatus !== "rejected"}
                           >
                              Відправити на перевірку
                           </CButton>
                        </div>
                     }
                  </>}
               </>}
         </CCardBody>
         <hr />

      </>
   )
}